import { observable, computed } from 'mobx';
import { serializable } from 'serializr';
import WorkflowStepStateBase from './../shared/workflowstepstate-base';
import Cons from '../../isomorphic/cons';

export default class WorkflowStepStateModel extends WorkflowStepStateBase {
    @serializable @observable data;
    @serializable @observable transitions;

    constructor(...args) {
        super(...args);

        this.isComplete = false;
        this.isSkipped = false;
        this.data = {};
        this.transitions = observable([]);
    }

    @computed get isNew() {
        return this.workflowStepStateId && this.workflowStepStateId.length < 36;
    }

    @computed get latestTransition() {
        if (this.transitions.length === 0) {
            return null;
        }

        return this.transitions[this.transitions.length - 1];
    }

    @computed get isMarkedNotApplicable() {
        return this.latestTransition && this.latestTransition.status === Cons.transitionTypes.NotApplicable;
    }
}



// WEBPACK FOOTER //
// ./src/workflow/workflow-step-state-model.js